import React, { useState, useEffect } from 'react';
import '../../CSS/Global.css';
import { useSidebar } from '../../SidebarContext';
import Header from '../Header';
import Sidebar from '../SideBar';
// import decryptUserCookie from './utils/decryptUserCookie';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import UnitModal from './UnitModal';
import { getDecryptedUserFromCookie } from '../utils/getCookie';
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight, LucideToggleLeft, LucideToggleRight, Pencil, Trash2 } from 'lucide-react';
import { useSearch } from '../../SearchContext';
import Loader from '../Loader';
import { decryptToken } from '../utils/getToken';

const Unit = () => {
    const { isSidebarOpen } = useSidebar();
    const [searchQuery, setSearchQuery] = useState('');
    // const userDetails = decryptUserCookie();
    const [categories, setCategories] = useState([]);
    const [filteredCategories, setFilteredCategories] = useState(categories);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const urlmain = process.env.REACT_APP_LINK
    const token = decryptToken("accessToken") || ""
    const user = getDecryptedUserFromCookie("gta_mainstateuser");
    const { globalSearch } = useSearch();
    const [load, setLoad] = useState(false);

    let main_id = "12345"
    // Effect to handle filtering
    const fetchCategories = async () => {
        setLoad(true);
        try {
            const response = await fetch(`${urlmain}/unit/${user.main_id}`, {
                method: "GET",
                // credentials: "include"
                headers: {
                    "Authorization": `Bearer ${token}`,
                }
            })
            const res = await response.json();
            console.log(res);
            setCategories(res.data.reverse());
        } catch (error) {
            console.log(error)
        } finally {
            setLoad(false);
        }
    }

    useEffect(() => {
        fetchCategories();
    }, [])


    useEffect(() => {
        const filtered = categories.filter((category) =>
            Object.values(category).some((value) =>
                String(value).toLowerCase().includes(globalSearch.toLowerCase())
            )
        );
        setFilteredCategories(filtered);
        setCurrentPage(1);
    }, [globalSearch, categories]);

    // Pagination Logic
    const totalPages = Math.ceil(filteredCategories.length / itemsPerPage);
    const currentData = filteredCategories.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    // Handlers
    const handleSearch = (e) => setSearchQuery(e.target.value);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);


    const toggleStatus = async (userId, currentStatus) => {
        const newStatus = currentStatus === "Active" ? "Inactive" : "Active";
        try {
            const response = await fetch(`${urlmain}/unit/toggle/${userId}`, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ status: newStatus }),
            });

            const result = await response.json();

            if (!result.isError) {
                const updated = categories.map(cat =>
                    cat.id === parseInt(userId) ? { ...cat, status: newStatus } : cat
                );
                setCategories(updated);
                toast.success(result.message);
            } else {
                toast.error(result.message);
            }
        } catch (error) {
            toast.error("Toggle failed");
        }
    };



    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        });

        if (result.isConfirmed) {
            try {
                const response = await fetch(`${urlmain}/unit/${id}`, {
                    method: "DELETE",
                    headers:{
                         Authorization: `Bearer ${token}`,
                    }
                });
                const res = await response.json();

                if (response.ok) {
                    setCategories(prev => prev.filter(cat => cat.id !== id));
                    Swal.fire('Deleted!', 'Unit has been deleted.', 'success');
                } else {
                    Swal.fire('Error', res.message || 'Delete failed', 'error');
                }
            } catch (error) {
                Swal.fire('Error', 'Something went wrong while deleting.', 'error');
            }
        }
    };


    const handleSave = async (data) => {
        try {
            const method = data.id ? "PUT" : "POST";
            const url = data.id
                ? `${urlmain}/unit/${data.id}`
                : `${urlmain}/unit/admin1997`;

            const response = await fetch(url, {
                method,
                headers: { "Content-Type": "application/json",
                     Authorization: `Bearer ${token}`,
                 },
                body: JSON.stringify(data),
            });
            const res = await response.json();
            const data1 = res.data;
            if (response.ok) {
                if (data.id) {
                    setCategories(prev => prev.map(cat => cat.id === data.id ? data : cat));
                    toast.success("Unit updated");
                } else {
                    setCategories(prev => [...prev, data1]);
                    toast.success("Unit added");
                }
            } else {
                toast.error(res.message || "Save failed");
            }
        } catch (error) {
            toast.error("Save error");
        }
    };



    if (load) {
        return (
           <Loader/>
        );
    }


    return (
        <>
           
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <div className="oms-header">
                    <h1 className="dashboard-title">Unit</h1>

                    {/* Add Offers Button */}
                    <button className="oms-add-btn" onClick={() => setIsModalOpen(true)}>
                        Add Unit
                    </button>
                </div>

                {/* Search Filter */}
                {/* <div className="filter-search">
                    <div className="filter-search-input">
                        <input
                            type="search"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                        <i className="fa fa-search"></i> 
                    </div>
                </div> */}

                {/* Customer Table */}
                <div className="customer-table responsive-table">
                    <table>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentData.length > 0 ? (
                                currentData.map((customer, index) => (
                                    <tr key={index}>
                                        <td>{customer.name}</td>
                                        <td>
                                            <button
                                                className={`status-toggle ${customer.status ? 'Active' : 'Inactive'}`}
                                                onClick={() => toggleStatus(customer.id, customer.status)}
                                            >
                                                {customer.status === "Active" ? (
                                                    <i className="fas fa-toggle-on"></i> // Active
                                                ) : (
                                                    <i className="fas fa-toggle-off"></i> // Inactive
                                                )}
                                            </button>
                                        </td>
                                        <td>
                                            <button className="edit-button" onClick={() => {
                                                setSelectedCategory(customer);
                                                setIsModalOpen(true);
                                            }}>
                                                <i className="fa-solid fa-pencil edit-oms"></i>
                                            </button>

                                            <button className="delete-button" onClick={() => handleDelete(customer.id)}>
                                                <i className="fa-solid fa-trash delete-oms"></i>
                                            </button>

                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="3" style={{ textAlign: 'center' }}>No Unit Added.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <div className="ecom-responsive-cards">
                    {currentData.length === 0 ? (
                        <p style={{ textAlign: "center", margin: "50px" }}>No Units Added</p>
                    ) : (
                        currentData.map((group, index) => (
                            <div className="ecom-responsive-card" key={index}>
                                <div className="ecom-responsive-header">
                                    <div className='p-toggle'>
                                        <p onClick={() => {
                                            let parsedProduct = group.product;
                                            try {
                                                if (typeof parsedProduct === "string") {
                                                    parsedProduct = JSON.parse(parsedProduct);
                                                    if (typeof parsedProduct === "string") {
                                                        parsedProduct = JSON.parse(parsedProduct);
                                                    }
                                                }
                                            } catch (e) {
                                                console.warn("Error parsing product:", e);
                                                parsedProduct = {};
                                            }

                                            setSelectedCategory({ ...group, product: parsedProduct });
                                            setIsModalOpen(true);
                                        }}>
                                            <Pencil size={20} style={{ marginRight: 4 }} /> <span>Edit</span>
                                        </p>


                                        <button
                                            className={`status-toggle ${group.status === "Active" ? 'Active' : 'Inactive'}`}
                                            onClick={() => toggleStatus(group.id, group.status)}
                                        >
                                            {group.status === "Active" ? (
                                                <>
                                                    <LucideToggleRight style={{ marginRight: 4 }} />
                                                    <span>Active</span>
                                                </>
                                            ) : (
                                                <>
                                                    <LucideToggleLeft style={{ marginRight: 4 }} />
                                                    <span>Inactive</span>
                                                </>
                                            )}
                                        </button>
                                    </div>

                                    <p>
                                        <Trash2 size={20} style={{ marginRight: 4 }} onClick={() => handleDelete(group.id)} /> <span>Delete</span>
                                    </p>
                                </div>

                                <div className="ecom-responsive-body">
                                    <div className="ecom-responsive-left">
                                        <h2>{group.name || "Not Provided"}</h2>
                                    </div>
                                </div>
                            </div>
                        ))
                    )}
                </div>

                {totalPages > 1 && (

                    <div className="pagination">
                        {/* First Page */}
                        <button
                            onClick={() => paginate(1)}
                            disabled={currentPage === 1}
                            className="pagination-chev-btn"
                        >
                            <ChevronsLeft size={18} />
                        </button>

                        {/* Previous Page */}
                        <button
                            onClick={() => paginate(currentPage - 1)}
                            disabled={currentPage === 1}
                            className="pagination-chev-btn"
                        >
                            <ChevronLeft size={18} />
                        </button>

                        {/* Current Page Number Only */}
                        <button className="pagination-btn active">
                            {currentPage}
                        </button>

                        {/* Next Page */}
                        <button
                            onClick={() => paginate(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            className="pagination-chev-btn"
                        >
                            <ChevronRight size={18} />
                        </button>

                        {/* Last Page */}
                        <button
                            onClick={() => paginate(totalPages)}
                            disabled={currentPage === totalPages}
                            className="pagination-chev-btn"
                        >
                            <ChevronsRight size={18} />
                        </button>
                    </div>
                )}

            </div>

            <UnitModal
                isOpen={isModalOpen}
                setIsOpen={setIsModalOpen}
                selectedCategory={selectedCategory}
                setSelectedCategory={setSelectedCategory}
                onSave={handleSave}
                categories={categories}
                setCategories={setCategories}
                fetchCategories={fetchCategories}
            />

        </>
    );
};

export default Unit;
